import {Container, Singleton} from "typescript-ioc";
import ThingModel from "@/model/ThingModel";
import StorageKey from "@/storage/StorageKey";
import BizStorage from './BizStorage';
import {LocalStorageWrapper} from "@/storage/StorageWrapper";

@Singleton
export default abstract class ThingModelStorage extends BizStorage<ThingModel> {
    protected key = StorageKey.THING_MODEL
}

class ThingModelStorageImpl extends ThingModelStorage {
    storage = Container.get(LocalStorageWrapper)
}

Container.bind(ThingModelStorage).to(ThingModelStorageImpl)
